<template>
    <div class='tops_body'>
        <div class="regist-companion-body">
            <!--<h2 class='reserve-accent-title pb-4 pb-sm-2 bg-single'>-->
            <h2 class='reserve-accent-title pb-sm-2 bg-single'>
                <span class="align-middle">同伴者リスト</span>
            </h2>
            <div v-if="mobileAppDataDisplayFlag">
                <div class="input-name py-1">
                    <div class="pr-2">
                        <div class="row my-1 mx-1">
                            <span class='label-1 col-3 d-flex align-items-center text-center'>お名前</span>
                            <input
                                id="player_name"
                                type="text"
                                class='form-control col-9'
                                :class="{'is-invalid': valid.player_name}"
                                maxlength="50"
                                placeholder="お名前"
                                v-model="addPlayerInfo.player_name"
                                @blur="CheckInputData"
                                @input="CheckInputData"
                                :disabled="playerNameDisabled"
                            >
                        </div>
                        <div v-if="valid.player_name" class="row my-1 mx-1">
                            <div class='col-3'></div>
                            <div class='col-9 invalid-feedback-message'>{{ validMessage.player_name }}</div>
                        </div>
                        <div v-if="mobileNumberDisb" class="row my-1 mx-1">
                            <span class='label-1 col-3 d-flex align-items-center text-center'>携帯番号</span>
                            <input
                                id="mobile_number"
                                type="text"
                                class='form-control col-9'
                                :class="{'is-invalid': valid.mobile_number, 'noPlaceholder': mobileNumberDisabled}"
                                maxlength="11"
                                placeholder="携帯番号"
                                v-model="addPlayerInfo.mobile_number"
                                @blur="CheckInputData"
                                @input="CheckInputData"
                                :disabled="mobileNumberDisabled"
                            >
                        </div>
                        <div v-if="valid.mobile_number" class="row my-1 mx-1">
                            <div class='col-3'></div>
                            <div class='col-9 invalid-feedback-message'>{{ validMessage.mobile_number }}</div>
                        </div>
                        <div v-if="emailDisb" class="row my-1 mx-1">
                            <span class='label-1 col-3 d-flex align-items-center text-center'>メール</span>
                            <input
                                id="email"
                                type="text"
                                class='form-control col-9'
                                :class="{'is-invalid': valid.email, 'noPlaceholder': emailDisabled}"
                                maxlength="256"
                                placeholder="aaa@aaa.jp"
                                v-model="addPlayerInfo.email"
                                @blur="CheckInputData"
                                @input="CheckInputData"
                                :disabled="emailDisabled"
                            >
                        </div>
                        <div v-if="valid.email" class="row my-1 mx-1">
                            <div class='col-3'></div>
                            <div class='col-9 invalid-feedback-message'>{{ validMessage.email }}</div>
                        </div>
                    </div>
                    <div class="d-flex justify-contents-center align-items-center">
                        <div class='col-4'>
                            <button class="w-100"
                                @click="clearPlayer"
                                :class="{'mypagedisabledbutton': clearDisabled , 'bluebackbutton': !clearDisabled}"
                                :disabled="clearDisabled">クリア</button>
                        </div>
                        <div class='col-4'>
                            <button
                                id="addBtn"
                                @click="CheckInputData"
                                class="w-100"
                                :class="{'mypagedisabledbutton': addDisabled , 'bluebackbutton': !addDisabled}"
                                :disabled="addDisabled"
                            >追加</button>
                        </div>
                        <div class='col-4'>
                            <button class="w-100"
                            @click="deletePlayer"
                            :class="{'mypagedisabledbutton': deleteDisabled , 'bluebackbutton': !deleteDisabled}"
                            :disabled="deleteDisabled">削除</button>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center my-3 px-1">
                    <div class="col-4 col-sm-6 p-0 mr-2">
                        <button @click="OnOpenSelectFriendDialog" class="bluebackbutton w-100">お友達を選ぶ</button>
                    </div>
                    <div class="col-8 col-sm-6 p-0">
                        <button class="nextBtn btn w-100 d-flex justify-content-center align-items-center" @click="OnCompanion">
                            <div class="lead">次&nbsp;&nbsp;へ&nbsp;&nbsp;</div>({{ selectNumber }}名選択中)
                        </button>
                    </div>
                </div>
                <div class="companion-list-area">
                    <div class="row-nomargin">
                        <span class="w-70 pl-2 add-friend">★はお友達登録済み</span>
                        <span class="w-30 text-center add-friend">お友達追加</span>
                    </div>
                    <div v-for="(item, index) in playerList" :key="item.id">
                        <div v-if="item.valid_flag == 1"
                            :class="{ 'disabledCompanion': item.pts_reserve_no }">
                            <div
                                class="w-100 d-flex justify-content-center align-items-center companionSelect"
                                @click="selectCompanion(index)"
                                :class="{ 'noSelectLine': !item.select_flag , 'selectLine': item.select_flag}"
                                :id="item.id"
                                :value="index"
                                >
                                <div class="w-10 text-center">{{ item.friend_flag ? '★' : '' }}</div>
                                <div class="w-30 player_name">{{ item.player_name }}</div>
                                <div class="w-30 mobile_number">{{ item.mobile_number }}</div>
                                <div class="w-30 text-center">
                                    <button
                                        class="bluebackbutton friendAddButton"
                                        v-if="!item.friend_flag && item.member_no != loginUserMemberNo"
                                        @click="FriendRegistCompanionList(index)"
                                    >追加
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="mobileAppHidden === false" class="d-flex justify-content-center align-items-center mt-3 w-100">
                    <div class="col-12 col-sm-6 p-0">
                        <button @click="OnMypage" class="mypagebackbutton w-100">一覧へ戻る</button>
                    </div>
                </div>
                <SelectFriendDialogModal
                    ref="SelectFriendDialogView"
                    v-show="showSelectFriendDialog"
                    v-on:fromSelectFriend-Dialog="OnInputSelectFriendDialog"
                    v-on:close-dialog="OnCloseSelectFriendDialog"
                ></SelectFriendDialogModal>
                <ErrorWordingDialog
                    v-show="showErrorWordingDialog"
                    v-bind:errorWording="errorWording"
                    v-on:closeErrorDialog="OnCloseErrorDialog"
                ></ErrorWordingDialog>
                <ConfirmDialog
                    v-if="showConfirmDialog"
                    initialMessage="同伴者を削除します。よろしいですか？"
                    doing="はい"
                    notDoing="いいえ"
                    :processing="processing"
                    @from-Dialog="OnConfirmDialogYes"
                    @closeBtn="OnConfirmDialogNo"
                />
            </div>
            <div v-else class="w-100 text-center mb-2">{{ mobileAppDisplayText }}</div>
        </div>
    </div>
</template>

<script>
import SelectFriendDialogModal from './dialog/SelectFriendDialog';
import ErrorWordingDialog from '../components/ErrorDialog';
import ConfirmDialog from '../components/ConfirmDialog';
import { GET_COMPANION_PLAYER_LIST,
        REGIST_COMPANION_LIST_PLAYER,
        REGIST_FRIEND_COMPANION_LIST,
        DELETE_COMPANION_LIST_PLAYER,
        REGIST_COMPANION_LIST_PLAYER_FRIEND } from '../../constants/companion_lists';
import validater from "../../lib/validater";

export default {
    components: {
        SelectFriendDialogModal,
        ErrorWordingDialog,
        ConfirmDialog
    },
    data () {
        return {
            loadingCount: 0,
            selectNumber: 0,
            showSelectFriendDialog: false,
            showErrorWordingDialog: false,
            showConfirmDialog: false,
            reserveNo: '',
            loginUserMemberNo: '',
            errorWording: '',
            emailDisb: false,
            mobileNumberDisb: false,
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            addPlayerInfo: {
                player_name: '',
                given_name: '',
                mobile_number: '',
                email: '',
                friend_flag: 0,
                valid_flag: 1
            },
            valid: {
                player_name: false,
                mobile_number: false,
                email: false
            },
            validMessage: {
                player_name: 'お名前を入力してください。',
                mobile_number: '携帯番号は「-」を除く11桁の数値で入力してください。',
                email: 'メール形式を満たした半角英数字で入力してください。'
            },
            playerList: [],
            selectedPlayerIndex: '',
            // モバイルアプリデータ表示フラグ
            mobileAppDataDisplayFlag: false,
            // モバイルアプリデータ非表示テキスト
            mobileAppDisplayText: '',
            // モバイルアプリ非表示フラグ
            mobileAppHidden: false,
            // 入力欄非活性フラグ
            playerNameDisabled: false,
            emailDisabled: false,
            mobileNumberDisabled: false,
            // ボタン非活性フラグ
            clearDisabled: true,
            addDisabled: false,
            deleteDisabled: true,
            // 削除データ
            deleteData: []
        };
    },
    created () {
        this.Initialize();
    },

    watch: {
    },
    computed: {
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async Initialize () {
            // モバイルアプリか判断する
            if (this.$store.state.auth.mobileAppFlag) {
                // モバイルアプリの場合、遷移ボタンを非表示にする
                this.mobileAppHidden = true;
            }
            if (this.$store.state.auth.mobileAppReserveNo) {
                this.reserveNo = this.$store.state.auth.mobileAppReserveNo;
            } else {
                if (sessionStorage.getItem('Reserve.reserveNo')) {
                    this.reserveNo = sessionStorage.getItem('Reserve.reserveNo');
                }
            }
            this.loginUserMemberNo = this.$store.state.auth.loginMember.member_no;
            await this.GetTogetherList();
        },
         /** ----------------------------------------------
         * 同伴者リスト取得
         * ---------------------------------------------- */
        GetTogetherList: async function () {
            var me = this;
            try {
                this.loadingOn();
                this.$apollo.query({
                        query: GET_COMPANION_PLAYER_LIST,
                        fetchPolicy: 'no-cache',
                        variables: {
                            reserve_no: this.reserveNo
                        }
                    }).then(res => {
                        // モバイルアプリ内にてログインユーザーと予約代表者が異なる場合、
                        if (res.data.GetCompanionPlayerList.CompanionLists === null) {
                            this.mobileAppDataDisplayFlag = false;
                            this.mobileAppDisplayText = '表示できるデータがありません。';
                        } else {
                            this.mobileAppDataDisplayFlag = true;
                            this.playerList = res.data.GetCompanionPlayerList.CompanionLists;

                            this.selectNumber = res.data.GetCompanionPlayerList.selectNumber;

                            this.emailDisb = Boolean(res.data.GetCompanionPlayerList.emailDisb);
                            this.mobileNumberDisb = Boolean(res.data.GetCompanionPlayerList.mobileNumberDisb);
                        }
                        me.loadingOff();
                    });
            } catch (error) {
                this.mobileAppDataDisplayFlag = false;
                this.mobileAppDisplayText = 'システムエラーが発生しました。';
                me.error = error;
                me.loadingOff();
            }
        },
        /** -----------------------------------------------------------
         * 同伴者選択処理
         * ------------------------------------------------------------ */
        selectCompanion (index) {
            // 未選択の場合
            if (this.playerList[index].select_flag === false) {
                this.playerList.forEach(ele => {
                    ele.select_flag = false;
                });
                // 選択行に背景色を付ける
                this.playerList[index].select_flag = true;
                // 入力フォームに非活性状態の入力情報を表示
                this.addPlayerInfo.player_name = this.playerList[index].player_name;
                this.addPlayerInfo.email = this.playerList[index].email;
                this.addPlayerInfo.mobile_number = this.playerList[index].mobile_number;
                // 入力フォーム非活性フラグ
                this.playerNameDisabled = true;
                this.emailDisabled = true;
                this.mobileNumberDisabled = true;
                // ボタン非活性フラグ
                this.clearDisabled = false;
                this.addDisabled = true;
                this.deleteDisabled = false;
                // 削除データ取得
                this.deleteData = this.playerList[index];
            } else {
            // 選択中の場合
                this.playerList[index].select_flag = false;
                this.addPlayerInfo.player_name = '';
                this.addPlayerInfo.email = '';
                this.addPlayerInfo.mobile_number = '';
                this.playerNameDisabled = false;
                this.emailDisabled = false;
                this.mobileNumberDisabled = false;
                this.clearDisabled = true;
                this.addDisabled = false;
                this.deleteDisabled = true;
                this.deleteData = [];
            }
        },
        /** ----------------------------------------------
         * クリアボタン押下処理
         * ---------------------------------------------- */
        clearPlayer() {
            // 選択中の同伴者を解除
            this.playerList.forEach(ele => {
                ele.select_flag = false;
            });
            this.addPlayerInfo.player_name = '';
            this.addPlayerInfo.email = '';
            this.addPlayerInfo.mobile_number = '';
            this.playerNameDisabled = false;
            this.emailDisabled = false;
            this.mobileNumberDisabled = false;
            this.clearDisabled = true;
            this.addDisabled = false;
            this.deleteDisabled = true;
            this.valid.player_name = false;
            this.valid.email = false;
            this.valid.mobile_number = false;
        },
        /** ----------------------------------------------
         * 同伴者登録処理
         * ---------------------------------------------- */
        RegistCompanionList() {
            var playerName = '';
            var nextPlayerNo = this.playerList[this.playerList.length - 1].player_no + 1;
            // 全角、半角スペースで名前を分割
            var playerNameReplace = this.addPlayerInfo.player_name.replace(/　/g," ");
            var arrayPlayerName = playerNameReplace.split(/\s/);
            for (var i = 0; i < arrayPlayerName.length; i++) {
                if (arrayPlayerName[i].length >= 1 && playerName.length >= 1){
                    playerName = playerName + ' ' + arrayPlayerName[i];
                } else if (arrayPlayerName[i].length >= 1 && playerName.length == 0){
                    playerName = arrayPlayerName[i];
                }
            }

            try {
                this.loadingOn();
                this.$apollo.mutate({
                        mutation: REGIST_COMPANION_LIST_PLAYER,
                        fetchPolicy: 'no-cache',
                        variables: {
                            reserve_no: this.reserveNo,
                            player_no: nextPlayerNo,
                            player_name: playerName,
                            mobile_number: this.addPlayerInfo.mobile_number,
                            email: this.addPlayerInfo.email
                        }
                    }).then(res => {
                        this.playerList = res.data.RegistCompanionListPlayer.CompanionLists;
                        this.selectNumber = res.data.RegistCompanionListPlayer.selectNumber;
                        this.addPlayerInfo.player_name = '';
                        this.addPlayerInfo.mobile_number = '';
                        this.addPlayerInfo.email = '';
                        this.loadingOff();
                    });
            } catch (error) {
                this.mobileAppDataDisplayFlag = false;
                this.mobileAppDisplayText = 'システムエラーが発生しました。';
                this.error = error;
                this.loadingOff();
            }
        },
        /** --------------------------------------------------------------
         * 削除ボタン押下処理
         * ----------------------------------------------------------- */
        deletePlayer() {
            // 確認ダイアログを開く
            this.showConfirmDialog = true;
        },
        /** --------------------------------------------------------------
         * 同伴者削除処理
         * ----------------------------------------------------------- */
        DeleteCompanionList() {
            try {
                this.loadingOn();
                this.$apollo.mutate({
                        mutation: DELETE_COMPANION_LIST_PLAYER,
                        fetchPolicy: 'no-cache',
                        variables: {
                            friend_id: this.deleteData.friend_id,
                            reserve_no: this.deleteData.reserve_no,
                            player_no: this.deleteData.player_no,
                            member_no: this.deleteData.member_no,
                            player_name: this.deleteData.player_name,
                            mobile_number: this.deleteData.mobile_number,
                            email: this.deleteData.email,
                            friend_flag: this.deleteData.friend_flag,
                            valid_flag: 0
                        }
                    }).then(res => {
                        this.playerList = res.data.DeleteCompanionListPlayer.CompanionLists;

                        this.selectNumber = res.data.DeleteCompanionListPlayer.selectNumber;
                        this.addPlayerInfo.player_name = '';
                        this.addPlayerInfo.email = '';
                        this.addPlayerInfo.mobile_number = '';
                        this.playerNameDisabled = false;
                        this.emailDisabled = false;
                        this.mobileNumberDisabled = false;
                        this.clearDisabled = true;
                        this.addDisabled = false;
                        this.deleteDisabled = true;
                        this.loadingOff();
                    });
            } catch (error) {
                this.mobileAppDataDisplayFlag = false;
                this.mobileAppDisplayText = 'システムエラーが発生しました。';
                this.error = error;
                this.loadingOff();
            }
        },
        /** --------------------------------------------------------------
         * お友達追加処理
         * ----------------------------------------------------------- */
        FriendRegistCompanionList(index) {
            try {
                this.loadingOn();
                this.$apollo.mutate({
                        mutation: REGIST_FRIEND_COMPANION_LIST,
                        fetchPolicy: 'no-cache',
                        variables: {
                            represent_member_no: this.loginUserMemberNo,
                            reserve_no: this.reserveNo,
                            player_no: this.playerList[index].player_no,
                            member_no: this.playerList[index].member_no,
                            player_name: this.playerList[index].player_name,
                            family_name: this.$store.state.auth.loginMember.family_name,
                            given_name: this.$store.state.auth.loginMember.given_name,
                            mobile_number: this.playerList[index].mobile_number,
                            email: this.playerList[index].email
                        }
                    }).then(res => {
                        this.playerList = res.data.RegistFriendCompanionList.CompanionLists;

                        this.selectNumber = res.data.RegistFriendCompanionList.selectNumber;
                        this.addPlayerInfo.player_name = '';
                        this.addPlayerInfo.email = '';
                        this.addPlayerInfo.mobile_number = '';
                        this.playerNameDisabled = false;
                        this.emailDisabled = false;
                        this.mobileNumberDisabled = false;
                        this.clearDisabled = true;
                        this.addDisabled = false;
                        this.deleteDisabled = true;
                        this.loadingOff();
                    });
            } catch (error) {
                this.mobileAppDataDisplayFlag = false;
                this.mobileAppDisplayText = 'システムエラーが発生しました。';
                this.error = error;
                this.loadingOff();
            }
        },
        /** ----------------------------------------------
         * マイページに戻る
         * ---------------------------------------------- */
        OnMypage: function () {
            sessionStorage.removeItem('MyPage.companionChangeFlg');
            this.$router.push('/mypage-reserve-list');
        },
        /** ----------------------------------------------
         * コンファムダイアログOK
         * ---------------------------------------------- */
        OnConfirmDialogYes: async function () {
            this.DeleteCompanionList();
            this.showConfirmDialog = false;
        },
        /** ----------------------------------------------
         * コンファムダイアログキャンセル
         * ---------------------------------------------- */
        OnConfirmDialogNo: function () {
            this.showConfirmDialog = false;
        },
        /** ----------------------------------------------
         * エラーダイアログ閉じる
         * ---------------------------------------------- */
        OnCloseErrorDialog: function () {
            this.showErrorWordingDialog = false;
        },
        /** ----------------------------------------------
         * お友達選択閉じるボタン押（ダイアログ）
         * ---------------------------------------------- */
        OnCloseSelectFriendDialog () {
            this.showSelectFriendDialog = false;
        },
        /** ----------------------------------------------
         * お友達選択登録ボタン押
         * ---------------------------------------------- */
        OnOpenSelectFriendDialog () {
            this.$refs.SelectFriendDialogView.GetFriendList(999, this.loginUserMemberNo);
            this.showSelectFriendDialog = true;
        },
        /** ----------------------------------------------
         * お友達選択登録ボタン押（ダイアログ）
         * ---------------------------------------------- */
        OnInputSelectFriendDialog (friendPlayer) {
            if (friendPlayer) {
                var friendList = [];
                var count = 0;
                for (let player of friendPlayer) {
                    var family_name = player.family_name ? player.family_name.trim() : '';
                    var given_name = player.given_name ? player.given_name.trim() : '';
                    var player_name = '';
                    if (given_name.length == 0) {
                        player_name = family_name;
                    } else {
                        player_name = family_name + ' ' + given_name;
                    }
                    // 既に同伴者リストに入っているお友達は含まない
                    if (!this.playerList.some( b => b.player_name == player_name && b.friend_flag == 1 && b.valid_flag == 1)) {
                        count++;
                        var nextPlayerNo = this.playerList[this.playerList.length - 1].player_no + count;

                        friendList.push(
                            {
                                id: nextPlayerNo + 10000,
                                friend_id: player.id,
                                reserve_no: this.reserveNo,
                                player_no: nextPlayerNo,
                                player_name: player_name,
                                mobile_number: player.mobile_number,
                                member_no: player.friend_member_no,
                                email: player.email,
                                friend_flag: 1,
                                add_friend_flag: 0,
                                valid_flag: 1,
                                pts_reserve_no: null
                            }
                        )
                    }
                }
                if (friendList.length != 0) {
                    try {
                        this.loadingOn();
                        this.$apollo.mutate({
                                mutation: REGIST_COMPANION_LIST_PLAYER_FRIEND,
                                fetchPolicy: 'no-cache',
                                variables: {
                                    FriendPlayerList: friendList
                                }
                            }).then(res => {
                                this.playerList = res.data.RegistCompanionListPlayerFriend.CompanionLists;

                                this.selectNumber = res.data.RegistCompanionListPlayerFriend.selectNumber;
                                this.addPlayerInfo.player_name = '';
                                this.addPlayerInfo.email = '';
                                this.addPlayerInfo.mobile_number = '';
                                this.playerNameDisabled = false;
                                this.emailDisabled = false;
                                this.mobileNumberDisabled = false;
                                this.clearDisabled = true;
                                this.addDisabled = false;
                                this.deleteDisabled = true;
                                this.loadingOff();
                            });
                    } catch (error) {
                        this.mobileAppDataDisplayFlag = false;
                        this.mobileAppDisplayText = 'システムエラーが発生しました。';
                        this.error = error;
                        this.loadingOff();
                    }
                }
            }
            this.showSelectFriendDialog = false;
        },
        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        CheckInputData: function(event) {
            if (event.type == "click") {
                if (event.target.id === "addBtn") {
                    if (!this.addPlayerInfo.player_name) {
                        this.validMessage.player_name = 'お名前を入力してください。';
                        this.valid.player_name = true;
                    } else {
                        this.valid.player_name = false;
                    }
                    if (this.addPlayerInfo.email) {
                        if (!validater.checkMail(this.addPlayerInfo.email)) {
                            this.validMessage.email = 'メール形式を満たした半角英数字で入力してください。';
                            this.valid.email = true;
                        } else {
                            this.valid.email = false;
                        }
                    }
                    if (this.addPlayerInfo.mobile_number) {
                        if (!validater.checkmobilenumberNoHyphen(this.addPlayerInfo.mobile_number)) {
                            this.validMessage.mobile_number = '携帯番号は「-」を除く11桁の数値で入力してください。';
                            this.valid.mobile_number = true;
                        } else {
                            this.valid.mobile_number = false;
                        }
                    }
                    if (this.CheckValidAllTrue()) {
                        // 重複チェック
                        if (this.CheckDuplicate(this.addPlayerInfo.player_name,
                                                this.addPlayerInfo.mobile_number,
                                                this.addPlayerInfo.email)) {
                            // 同伴者登録
                            this.RegistCompanionList();
                        } else {
                            this.validMessage.player_name = '既に同姓同名の方が登録されています。';
                            this.valid.player_name = true;
                        }
                    }
                }
            } else if (event.type === "blur"){
                this.valid.mobile_number = false;
                this.valid.email = false;
                if (event.target.value) {
                    if (event.target.id === "player_name") {
                        this.valid.player_name = false;
                    } else if (event.target.id === "email") {
                        if (!validater.checkMail(this.addPlayerInfo.email)) {
                            this.validMessage.email = 'メール形式を満たした半角英数字で入力してください。';
                            this.valid.email = true;
                        }
                    } else if (event.target.id === "mobile_number") {
                        if (!validater.checkmobilenumberNoHyphen(this.addPlayerInfo.mobile_number)) {
                            this.validMessage.mobile_number = '携帯番号は「-」を除く11桁の数値で入力してください。';
                            this.valid.mobile_number = true;
                        }
                    }
                }
            } else if (event.type === "input"){
                if (this.addPlayerInfo.player_name === '' &&
                    this.addPlayerInfo.email === '' &&
                    this.addPlayerInfo.mobile_number === '') {
                        this.clearDisabled = true;
                    } else {
                        this.clearDisabled = false;
                    }
            }
        },
        /** ----------------------------------------------
         * バリデーションがすべてtrueか確認
         * ---------------------------------------------- */
        CheckValidAllTrue: function () {
            for (let key in this.valid) {
                if (this.valid[key]) {
                    return false;
                }
            }
            return true;
        },
        /** ----------------------------------------------
         * 重複チェック
         * ---------------------------------------------- */
        CheckDuplicate: function (playerName, mobileNnumber, email) {
            for (let player of this.playerList) {
                // 有効フラグ0は削除されているので除外
                if (player.valid_flag != 1) {
                    continue;
                }
                if (player.player_name.replace(/\s+/g, "") == playerName.replace(/\s+/g, "")) {
                    // 携帯番号入力が可能の場合
                    if (this.mobileNumberDisb) {
                        // どちらもデータが無ければ一致として判断
                        if (player.mobile_number == null && mobileNnumber == null) {
                            return false;
                        }
                        // playerListのデータがあって、一致していれば
                        if (player.mobile_number == mobileNnumber && player.mobile_number) {
                            return false;
                        }
                    }
                    // Eメール入力が可能の場合
                    if (this.emailDisb) {
                        // どちらもデータが無ければ一致として判断
                        if (player.email == null && email == null) {
                            return false;
                        }
                        // playerListのデータがあって、一致していれば
                        if (player.email == email && player.email) {
                            return false;
                        }
                    }

                }
            }
            return true;
        },
        /** ----------------------------------------------
         * 同伴者画面推移
         * ---------------------------------------------- */
        OnCompanion: function () {
            this.$router.push({ path: "/registcompanion" });
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function (){
            this.loadingCount++;
            this.$store.commit("loading/setIsLoading", true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function (){
            this.loadingCount--;
            if (this.loadingCount == 0) {
                this.$store.commit("loading/setIsLoading", false);
            }
        },

    }
}

</script>

<style scoped>
.classicbackbutton{
    border-radius: 0.3rem;
}
.th_400{
    width: 400px;
}
.th_80{
    width: 80px;
}
.th_70{
    width: 70px;
}
.w-40{
    width: 40%;
    max-width: 40%;
}
.w-30{
    width: 30%;
    max-width: 30%;
}
.w-10{
    width: 10%;
    max-width: 10%;
}
.w-80 {
    width: 80%;
    max-width: 80%;
}
.w-70 {
    width: 70%;
    max-width: 70%;
}
.w-20 {
    width: 20%;
    max-width: 20%;
}
.col-6-w-40{
    width: 40%;
    max-width: 40%;
}
.invalid-feedback-message{
    width: 100%;
    font-size: 100%;
    color: #dc3545;
}
.row-nomargin{
    display: flex;
    flex-wrap: wrap;
}
.parent {
    display:block;
    white-space: nowrap;
}
.return{
    float: right;
    text-decoration: underline;
    font-size: 0.9rem;
    cursor: pointer;
    color: #207474;
}
.return:hover{
    color: blue;
}
.cell-check{
    font-size: 1.5rem;
}
.input-name{
    border-radius: 10px;
    background: white;
}
.height-clac {
    height: calc(1.5em + 0.75rem + 2px);
}
.frend-icon {
    display: inline-block;
    max-width: 6.333333%;
    /* flex: 0 0 6.333333%; */
}
.friend-line {
    display: inline-block;
}
.friend-mark {
    text-align: right;
}
.companion-list-area {
    border-radius: 10px;
    min-height: 285px;
    max-height: 285px;
    background: white;
    overflow-y: scroll;
}

.nextBtn {
    font-size: 1rem;
    text-decoration: none;
    color: #ffffff;
    background-image: linear-gradient(#FFC107 0%, #FF6928 100%);
}

.companionSelect {
    height: 35px;
}

.friendAddButton {
    height: 30px;
    pointer-events: auto;
}

.noSelectLine {
    background-color: #ffffff;
}
/* .nextBtn:hover {
    background-image: linear-gradient(#e2ac08 0%, #cf5825 100%);
} */

.regist-companion-body {
    padding-top: 5px;
    width: 600px;
    margin: 0 auto;
}

.text-control {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.disabledCompanion {
    pointer-events: none;
}

.noPlaceholder::placeholder{
    color: transparent;
}

@media screen and (max-width: 575px) {
    .add-friend{
        font-size: 0.85rem;
    }
    .label-1{
        padding-left: 5px;
        padding-right: 10px;
    }
    .btn-1{
        padding-left: 10px;
        padding-right: 10px;
    }
    .col-6-w-40{
        width: 100%;
        max-width: 100%;
    }
    .player_name,
    .mobile_number{
        font-size: 0.9rem;
    }
}

@media screen and (max-width: 896px) {

    .regist-companion-body {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
}
</style>
